function ImportHotjar() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  if (window.location.href.indexOf('uat') > -1) {
    script.innerHTML = `<!-- Hotjar Tracking Code for https://uat.deathnotification.gov.au/ -->
    (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:2487149,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
       })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
  } else {
    if (window.location.href.indexOf('deathnotification') > -1) {
      script.innerHTML = `<!-- Hotjar Tracking Code for https://uat.deathnotification.gov.au/ -->
      (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2391872,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
         })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    } else {
      script.innerHTML = `<!-- Hotjar Tracking Code for https://localhost:3001 -->
      (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:2486472,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    }
  }

  script.async = true;
  document.body.appendChild(script);
}

export default ImportHotjar;
